const api = require('./api');

module.exports = {
  api
};
